"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCircleShape = void 0;
const CircleDrawer_1 = require("./CircleDrawer");
function loadCircleShape(tsParticles) {
    tsParticles.addShape("circle", new CircleDrawer_1.CircleDrawer());
}
exports.loadCircleShape = loadCircleShape;
